import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import SignaturePad from 'react-signature-pad-wrapper';
import styles from './SignaturePad.less';

class SignatureField extends Component {
  static propTypes = {
    field: PropTypes.shape({}).isRequired,
    form: PropTypes.shape({}).isRequired,
    handleShowSignaturePad: PropTypes.func.isRequired,
    label: PropTypes.string,
    showPreviousButton: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    label: '',
  }

  componentWillMount() {
    const { field: { name }, form: { setFieldValue } } = this.props;
    setFieldValue(name, '');
  }

  handleOnEnd = () => {
    const { field: { name }, form: { setFieldValue } } = this.props;
    const imageB64 = this.signaturePad.toDataURL();
    setFieldValue(name, imageB64);
  }

  clear = () => {
    const { field: { name }, form: { setFieldValue } } = this.props;
    this.signaturePad.clear();
    setFieldValue(name, '');
  }

  handleBack = () => {
    const { field: { name }, form: { setFieldValue }, handleShowSignaturePad } = this.props;
    setFieldValue(name, '_');
    handleShowSignaturePad();
  }

  render() {
    const {
      showPreviousButton,
      label,
      form: { touched, errors },
      field: { name, value },
    } = this.props;

    return (
      <Form.Field>
        <div className={styles.label}>{label}</div>
        <div className={styles.signaturePad}>
          <SignaturePad
            options={{ penColor: 'black', onEnd: this.handleOnEnd }}
            ref={(ref) => { this.signaturePad = ref; }}
          />
        </div>
        {
          touched[name]
            && errors[name]
            && <div className={styles.error}>{errors[name]}</div>
        }
        <div className={styles.buttonPosition}>
          {value && value !== '_' && <button type="button" onClick={this.clear} className={styles.linkButton}>Clear</button>}
          { showPreviousButton
          && <button type="button" onClick={this.handleBack} className={styles.linkButton}>Back to previous</button>}
        </div>
      </Form.Field>
    );
  }
}

export default SignatureField;
